import { userSchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchUserData = async () => {
  const response: any = await fetchApi(`/clients/me`, {
    query: {
      'with[]': ['address'],
    },
  })

  const data = userSchema.parse({
    id: response.data?.id,
    firstName: response.data?.first_name,
    lastName: response.data?.last_name,
    emailAddress: response.data?.email,
    phoneNumber: response.data?.phone,
    address: response.data?.address
      ? {
          line1: response.data?.address.line_1,
          line2: response.data?.address.line_2,
          city: response.data?.address.city,
          postcode: response.data?.address.postcode,
          country: response.data?.address.country,
        }
      : undefined,
  })

  return data
}

export type UserData = Awaited<ReturnType<typeof fetchUserData>>
